import { StyledColumn } from './styles'

export function Column({
  children,
  width,
  flexDirection = 'column',
  flexWrap = 'nowrap',
}) {
  return (
    <StyledColumn
      width={width}
      flexDirection={flexDirection}
      flexWrap={flexWrap}
      className="column-wrapper"
    >
      {children}
    </StyledColumn>
  )
}
